import { saveAs } from 'file-saver';
import { unparse } from 'papaparse';
import "isomorphic-fetch";

export default class ESCSVExporter {
  constructor(esAppName, esURL) {
    this.esAppName = esAppName || 'elasticsearch_index_ti_products';
    this.esURL = esURL || 'https://ti-elastic.76design.com';
    this.esType = 'products';
    this.jsonData = [];
    this.filename = 'products.csv';
  }

  getScrollApiData(data) {
    if(data.error) {
      console.log(data.error.reason);
      // TODO: Should find a way to display the error to the user, or at least that there was one
      return null;
    }

    const hits = data.hits.hits;
    this.jsonData = this.jsonData.concat(hits);
    let str = null;
    /**
     * Checking if the current data length is less then the total hits from the ES results,
     * If yes calling the scrollApi function again to fetch the remaining data.
     *
     * */
    if (this.jsonData.length < data.hits.total) {
      const scrollObj = {
        scroll: '1m',
        scroll_id: data._scroll_id
      };
      this.scrollApi({ activeQuery: scrollObj, scroll: true, scroll_id: data._scroll_id });
    } else {
      str = JSON.stringify(this.jsonData, null, 4);
      this.jsonData = [];
    }
    return str;
  }

  defaultQuery() {
    return { query: { match_all: {} } }
  }

  exportData(query, filename) {
    const activeQuery = query ? query : this.defaultQuery();
    this.filename = filename ? filename : this.filename;
    this.scrollApi({activeQuery})
  }

  scrollApi(info) {
    this.scrollQuery(info.activeQuery, info.scroll, info.scroll_id)
      .then((res) => {
        const data = this.getScrollApiData(res);
        if (data) {
          try {
            let exportData = JSON.parse(data);

            //exportData = exportData.map((value) => {
            //
            //});

            exportData = exportData.map((value) => {
              let item = Object.assign(value, value._source);
              item = {
                "Product Title": item.product_name ? item.product_name[0] : "",
                "Description": item.short_description ? item.short_description[0] : "",
                "Manufacturer": item.manufacturer_name || "",
                "Analysis Type": item.analysis_type_name ? item.analysis_type_name[0] : "",
                "Device Type": item.device_type_name ? item.device_type_name[0] : "",
                "Item Code": item.product_item_code ? item.product_item_code[0] : "",
                "Product Code": item.product_code ? item.product_code[0] : "",
              };
              return this.flatten(item);
            });

            // Unparsing the data using papaparse package,
            // A Custom implementation can also be accepted
            const newData = unparse(exportData);

            let file = null;
            if(typeof File === 'function') {
              file = new File([newData], this.filename, { type: 'text/comma-separated-values;charset=utf-8' });
            } else {
              file = new Blob([newData], this.filename, { type: 'text/comma-separated-values;charset=utf-8' });
            }
            // Downloading the file using file-saver package
            saveAs(file);
          } catch (e) {
            console.error(e);
          }
        }
      });
  }

  /**
   * A function to convert multilevel object to single level object and use key value pares as Column and row pairs using recursion
   */
  flatten(data) {
    const result = {};
    function recurse(cur, prop = '') {
      if (Object(cur) !== cur) {
        result[prop] = cur;
      } else if (Array.isArray(cur)) {
        const l = cur.length;
        for (let i = 0; i < l; i += 1) {
          recurse(cur[i], `${prop}[${i}]`);
        }
        if (l === 0) {
          result[prop] = [];
        }
      } else {
        let isEmpty = true;
        Object.keys(cur).forEach((p) => {
          isEmpty = false;
          recurse(cur[p], prop ? `${prop}.${p}` : p);
        });
        if (isEmpty && prop) {
          result[prop] = {};
        }
      }
    }

    recurse(data);
    return result;
  }

  /**
   * Setting up the query,
   * If scrollId is defined then it will continue the last scroll call and fetch the next chunk of data.
   */
  scrollQuery(queryBody, scroll, scrollId) {
    const createUrl = `${this.esURL}/${this.esAppName}/${this.esType}/_search?scroll=5m`;
    const scrollUrl = `${this.esURL}/_search/scroll?scroll=5m&scroll_id=${scrollId}`;
    const finalUrl = scroll ? scrollUrl : createUrl;
    queryBody.size = 1000;
    return scroll ? this.applyQuery(finalUrl) : this.applyQuery(finalUrl, queryBody);
  }

  applyQuery(url, queryBody) {
    if (queryBody) {
      return fetch(url, {
        method: 'POST',
        headers: {
          //Authorization: `Basic ${btoa(credentials)}`,
          'content-type': 'application/json'
        },
        // credentials: 'include',
        body: JSON.stringify(queryBody)
      }).then(data => data.json());
    } else {
      return fetch(url).then(data => data.json());
    }
  }
}
